import * as React from 'react';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import AppBar from '../components/AppBar';
import Toolbar from '../components/Toolbar';

const rightLink = {
  fontSize: 16,
  color: 'common.white',
  ml: 3,
};

function AppAppBar() {
  return (
    <div>
      <AppBar position="fixed">
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <Box sx={{ flex: 1 }} />
          <Link
            variant="h6"
            underline="none"
            color="inherit"
            // href="/premium-themes/onepirate/"
            href="/"
            sx={{ fontSize: 24 }}
          >
            {/* {'peleza International'} */}
            <img
                    src="/static/logo.png"
                    alt="Peleza Logo"
                  />
          </Link>
          <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
            {/* <Link
              color="inherit"
              variant="h6"
              underline="none"
              // href="/premium-themes/onepirate/sign-in/"
              href="#"
              sx={rightLink}
            >
              {'About'}
            </Link> */}
            <Link
              variant="h6"
              underline="none"
              href="https://peleza.com/contact/"
              sx={{ ...rightLink, color: 'secondary.main' }}
            >
              {'Contact'}
            </Link>
          </Box>
        </Toolbar>
      </AppBar>
      <Toolbar />
    </div>
  );
}

export default AppAppBar;
